"use strict";

var _regeneratorRuntime = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _classCallCheck = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var filter_1 = require("./filter");

var CallCredentialsFilter =
/*#__PURE__*/
function (_filter_1$BaseFilter) {
  _inherits(CallCredentialsFilter, _filter_1$BaseFilter);

  function CallCredentialsFilter(channel, stream) {
    var _this;

    _classCallCheck(this, CallCredentialsFilter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CallCredentialsFilter).call(this));
    _this.channel = channel;
    _this.stream = stream;
    _this.channel = channel;
    _this.stream = stream;
    var splitPath = stream.getMethod().split('/');
    var serviceName = '';
    /* The standard path format is "/{serviceName}/{methodName}", so if we split
     * by '/', the first item should be empty and the second should be the
     * service name */

    if (splitPath.length >= 2) {
      serviceName = splitPath[1];
    }
    /* Currently, call credentials are only allowed on HTTPS connections, so we
     * can assume that the scheme is "https" */


    _this.serviceUrl = "https://".concat(stream.getHost(), "/").concat(serviceName);
    return _this;
  }

  _createClass(CallCredentialsFilter, [{
    key: "sendMetadata",
    value: function sendMetadata(metadata) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var channelCredentials, streamCredentials, credentials, credsMetadata, resultMetadata;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                channelCredentials = this.channel.credentials._getCallCredentials();
                streamCredentials = this.stream.getCredentials();
                credentials = channelCredentials.compose(streamCredentials);
                credsMetadata = credentials.generateMetadata({
                  service_url: this.serviceUrl
                });
                _context.next = 6;
                return metadata;

              case 6:
                resultMetadata = _context.sent;
                _context.t0 = resultMetadata;
                _context.next = 10;
                return credsMetadata;

              case 10:
                _context.t1 = _context.sent;

                _context.t0.merge.call(_context.t0, _context.t1);

                return _context.abrupt("return", resultMetadata);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }]);

  return CallCredentialsFilter;
}(filter_1.BaseFilter);

exports.CallCredentialsFilter = CallCredentialsFilter;

var CallCredentialsFilterFactory =
/*#__PURE__*/
function () {
  function CallCredentialsFilterFactory(channel) {
    _classCallCheck(this, CallCredentialsFilterFactory);

    this.channel = channel;
  }

  _createClass(CallCredentialsFilterFactory, [{
    key: "createFilter",
    value: function createFilter(callStream) {
      return new CallCredentialsFilter(this.channel, callStream);
    }
  }]);

  return CallCredentialsFilterFactory;
}();

exports.CallCredentialsFilterFactory = CallCredentialsFilterFactory;